export class AccountantPouchMiniEntity {
  id?: number
  userId?: string
  userDisplayName?: string | null
  amount?: number
  lastInTransactionAt?: string | null
  lastOutTransactionAt?: string | null
  totalTransactionAmount?: number
}
